"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dd_api_1 = __importDefault(require("../dd-api"));
const functions_1 = require("../../helpers/functions");
class DDSmsApi extends dd_api_1.default {
    constructor(api_host, client) {
        super(api_host, client);
    }
    async sendSms(mobileNumber, message) {
        const formattedNumber = (0, functions_1.checkAndCleanMobileNumber)(mobileNumber);
        const response = await this.post(`/v2/sms-messages/send-to/${formattedNumber}`, {
            message: message
        });
        return response;
    }
}
exports.default = DDSmsApi;
//# sourceMappingURL=dd-sms-api.js.map